<template>
  <VCard class="payment-method-wrapper" :color="ColorType.white">
    <VSection title="결제수단" :padding="[25, 15, 5, 15]" :useUnderline="false"></VSection>
    <div id="baemin-pay-rendered-component"></div>
  </VCard>
  <!-- <VCard class="payment-method-wrapper">
    <VBlock class="payment-method" :sort="Sort.space_between">
      <VSpan :text="paymentMethod.displayName" :size="20" />
      <VA :onClick="onPaymentMethod">
        <VSpan class="detail" text="변경" :size="14" :color="TextColor.brand" />
      </VA>
    </VBlock>
  </VCard>-->
</template>

<script>
// import VSpan, { TextColor } from '../../atoms/VSpan/index'
// import VA from '../../molecules/VA/index'
import { renderPaymentMethodSelectionFieldFlow, ReactDomUnmount } from 'baeminpay-front/build/index'
import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock'

import VSection from '../../molecules/VSection'
import VCard, { ColorType } from '../../molecules/VCard'

import { MoveType, Smartbaedal } from '@/plugins/AppManager'
import { LogEvent, LogGroup, LogScreenName, LogType } from '@/plugins/AppLogManager'
import { GlobalFunctionName, setGlobalFunction } from '@/utils/nativeBridge'

import { StoreProps, PaymentMethodSelectionFieldFlowProps } from '@/models/PreOrder/BaeminPaymentMethod'

export default {
  name: 'PreOrderPaymentMethod',
  // components: { VA, VSpan, VBlock, VCard },
  components: { VCard, VSection },
  props: {
    paymentMethod: {
      type: Object,
      required: true
    },
    paymentNotices: Array,
    paymentMethodOptions: Array,
    onPaymentMethod: {
      type: Function,
      required: true
    },
    isUnsignChangeSign: Boolean,
    onClickNativeBack: Function
  },
  mounted() {
    if (this.isUnSign) this.isUnsignedHistory = true
    this.renderBaeminPay()
  },
  computed: {
    isUnSign() {
      return !this.$store.getters.isSign
    },
    appVersion() {
      return this.$store.getters.appVersion
    }
  },
  watch: {
    paymentMethod() {
      if (!this.isFirst && this.isUnsignedHistory && !this.isUnSign && this.renderedBaeminPay) {
        this.destroyBaeminpay()
        setTimeout(() => {
          this.renderBaeminPay()
        }, 100)
        this.isFirst = true
      }
    }
  },
  methods: {
    recursiveInsertClassName(elem) {
      if (elem.getAttribute('body-scroll-lock-ignore') === null && elem.id !== 'baeminpay-modal-container')
        elem.setAttribute('body-scroll-lock-ignore', '')

      for (let i = 0; i < elem.children.length; i++) {
        this.recursiveInsertClassName(elem.children[i])
      }
    },

    redirectLoginPage() {
      this.$store.dispatch('modal/close')
      this.$appManager.moveSimple(Smartbaedal.LOGIN, MoveType.PUSH)
    },

    renderBaeminPay() {
      const { baeminMemberNo, isSign, appVersion, isAndroid } = this.$store.getters

      const storeProps = new StoreProps({
        memberNumber: baeminMemberNo,
        externals: {
          deeplink: process.env.VUE_APP_DEEP_LINK_PROTOCOL,
          action: process.env.VUE_APP_BAEMIN_ACTION_DEEP_LINK_PROTOCOL,
          INTERNAL_WEB: process.env.VUE_APP_BAEMIN_INTERNAL_WEB
        },
        logData: {
          env: process.env.NODE_ENV === 'production' ? 'RELEASE' : 'TEST',
          sessionId: this.$store.getters.sessionId,
          dvcId: this.$store.getters.deviceId,
          screenName: 'Ord',
          serviceName: 'BMART'
        },
        setAndroidBackHandler: (onClose) => {
          window.onClickNativeBack = () => {
            onClose()
            window.onClickNativeBack = this.onClickNativeBack
          }
        }
      })

      const pocketNo = !this.paymentMethod.baeminpay ? null : this.paymentMethod.baeminpay.pocketNo
      const appVersionDeviceTypePrefix = isAndroid ? 'and1_' : 'iph1_'

      const defaultPaymentMethod = this.paymentMethodOptions.find((method) => method.default)

      const paymentMethodProps = new PaymentMethodSelectionFieldFlowProps({
        selectedCode: this.paymentMethod.code,
        defaultPaymentMethodCode: defaultPaymentMethod ? defaultPaymentMethod.code : this.paymentMethod.code,
        paymentMethodList: this.paymentMethodOptions.map((method) => ({
          code: method.code,
          // typeCode: method.code,
          method: method.codeName,
          displayName: method.displayName,
          promotion: method.promotion,
          notice: '',
          availableCashReceipt: method.availableCashReceipt,
          availableGuest: method.availableGuest,
          default: method.default,
          disable: method.disable,
          defaultYn: method.default ? 'Y' : 'N',
          disableDescription: method.disableDescription
        })),
        selectedBaeminpayPocketNo: pocketNo,
        appVersion: appVersionDeviceTypePrefix + appVersion,
        guest: !isSign,
        goLogin: () => {
          this.redirectLoginPage()
        },
        onSelect: (method) => {
          this.$store.commit('preOrder/setPaymentMethod', {
            ...method,
            codeName: this.paymentMethodOptions.find((option) => option.displayName === method.displayName).codeName
          })

          // setGlobalFunction(GlobalFunctionName.ON_CLICK_NATIVE_BACK, this.onClickNativeBack)
          window.onClickNativeBack = this.onClickNativeBack
          enableBodyScroll(this.baeminpayElement)
        },
        onTogglePopup: (show) => {
          if (show) {
            const { appVersion } = this.$store.getters
            this.$store.commit('hideNavigationBar', { appVersion })
            this.beforeScrollY = window.scrollY
            window.scrollTo(0, 0)

            this.recursiveInsertClassName(this.baeminpayElement)

            disableBodyScroll(this.baeminpayElement, {
              allowTouchMove: (el) => {
                while (el && el !== document.body) {
                  if (el.getAttribute('body-scroll-lock-ignore') !== null) {
                    return true
                  }

                  el = el.parentNode
                }
              }
            })

            this.baeminpayElement.children[0].children[0].style.overflowY = 'auto'
            document.getElementById('app').style.overflowY = 'hidden'
          } else {
            const { appVersion } = this.$store.getters
            this.$store.commit('showNavigationBar', { appVersion })
            enableBodyScroll(this.baeminpayElement)
            document.getElementById('app').style.removeProperty('overflow-y')
            window.onClickNativeBack = this.onClickNativeBack
            window.scrollTo(0, this.beforeScrollY)
          }
        }
      })

      // HISTORY :: 주문지면에서는 message만 받는다, DISCOUNT = 할인 (검은 텍스트) INCIDENT = 장애 (빨간 텍스트)
      const paymentNoticesWrapped = this.paymentNotices.reduce(
        (acc, curr) => {
          if (curr.type === 'DISCOUNT') acc[0].push(curr.message)
          else if (curr.type === 'INCIDENT') acc[1].push(curr.message)

          return acc
        },
        [[], []]
      )

      const [discount, incident] = paymentNoticesWrapped

      // HISTORY :: 필드가 빈값이라면 (빈배열) => 필드를 보내주지 말아야 함 => 배민페이 히스토리
      const noticeInfo = {}
      if (discount.length > 0) noticeInfo.discountNotiContents = discount
      if (incident.length > 0) noticeInfo.incidentNotiContents = incident

      const orderSheetKey = this.$store.getters['preOrder/orderSheetKey']

      renderPaymentMethodSelectionFieldFlow('baemin-pay-rendered-component', {
        ...storeProps,
        ...paymentMethodProps,
        ...noticeInfo,
        orderNumber: orderSheetKey
      })

      this.renderedBaeminPay = true

      this.baeminpayElement = document.getElementById('baeminpay-modal-container')
    },

    destroyBaeminpay() {
      const element = document.getElementById('baemin-pay-rendered-component')
      ReactDomUnmount(element)

      while (element.hasChildNodes()) element.removeChild(element.firstChild)
    },

    paymentLog() {
      const params = {
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M3
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD_PURCH_METHOD,
        type: LogType.VIEW,
        params
      })
    }
  },
  beforeDestory() {
    this.destroyBaeminpay()
  },
  data() {
    return {
      ColorType,
      renderedBaeminPay: false,
      isUnsignedHistory: false,
      isFirst: false,
      paymentMethodClose: () => {},
      beforeScrollY: 0,
      baeminpayElement: null
      // baeminpayEventHandler: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.payment-method-wrapper {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
  display: block;

  // background-color: $background-white;

  /* border-bottom: 1px solid $light-gray-5; */
}
</style>
